export default {
  // Common
  common: {
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    search: '搜索',
    filter: '筛选',
    reset: '重置',
    submit: '提交',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '关闭',
    yes: '是',
    no: '否',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '提示',
    all: '全部',
    none: '无',
    enabled: '已启用',
    disabled: '已禁用',
    active: '活跃',
    inactive: '非活跃',
    pending: '待处理',
    completed: '已完成',
    failed: '失败',
    view: '查看',
    details: '详情',
    actions: '操作',
    status: '状态',
    date: '日期',
    time: '时间',
    amount: '数量',
    price: '价格',
    total: '总计',
    fee: '手续费',
    balance: '余额',
    available: '可用',
    locked: '锁定',
    copy: '复制',
    copied: '已复制!',
    download: '下载',
    upload: '上传',
    refresh: '刷新',
    more: '更多',
    less: '收起',
    optional: '可选',
    required: '必填',
    clear: '清除',
    retry: '重试',
    name: '名称',
    manage: '管理',
    submitted: '已提交',
  },

  // Navigation
  nav: {
    home: '首页',
    dashboard: '仪表盘',
    overview: '概览',
    portfolio: '资产组合',
    trade: '交易',
    tradeNow: '开始交易',
    markets: '市场',
    wallet: '钱包',
    orders: '订单',
    myAssets: '我的资产',
    createAsset: '创建资产',
    kyc: '身份认证',
    settings: '设置',
    profile: '个人资料',
    security: '安全',
    notifications: '通知',
    help: '帮助',
    logout: '退出登录',
    login: '登录',
    register: '注册',
  },

  // Home page
  home: {
    hero: {
      title: '资产代币化',
      subtitle: '将真实资产转化为可交易的数字代币。解锁流动性，实现分割所有权，进入全球市场。',
      getStarted: '立即开始',
      exploreAssets: '探索资产',
    },
    features: {
      title: '一站式解决方案',
      subtitle: '数字资产代币化和交易的完整平台',
      tokenization: {
        title: '资产代币化',
        description: '将真实资产转化为数字代币，完全符合监管合规要求。',
      },
      trading: {
        title: '高级交易',
        description: '使用我们的高性能撮合引擎进行交易，支持限价单和市价单。',
      },
      security: {
        title: '安全合规',
        description: '企业级安全保障，每笔交易都内置 KYC/AML 合规检查。',
      },
      revenue: {
        title: '收益分配',
        description: '自动向代币持有者分配股息和收益。',
      },
    },
    cta: {
      title: '准备好开始代币化了吗？',
      subtitle: '加入已在 TokenForge 上完成资产代币化的众多资产所有者。',
      button: '创建您的账户',
    },
  },

  // Auth
  auth: {
    login: '登录',
    loginRequired: '请登录后继续',
    loginPage: {
      title: '登录',
      subtitle: '欢迎回来！请登录以继续。',
      email: '邮箱',
      password: '密码',
      rememberMe: '记住我',
      forgotPassword: '忘记密码？',
      noAccount: '还没有账户？',
      signUp: '立即注册',
      submit: '登录',
      loading: '登录中...',
    },
    register: {
      title: '创建账户',
      subtitle: '加入 TokenForge 开始交易。',
      username: '用户名',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      displayName: '显示名称',
      termsAgree: '我同意服务条款和隐私政策',
      haveAccount: '已有账户？',
      signIn: '立即登录',
      submit: '创建账户',
      loading: '创建中...',
    },
    forgotPassword: {
      title: '重置密码',
      subtitle: '输入您的邮箱以接收密码重置链接。',
      email: '邮箱',
      submit: '发送重置链接',
      loading: '发送中...',
      success: '密码重置邮件已发送，请查收。',
      backToLogin: '返回登录',
    },
    twoFactor: {
      title: '两步验证',
      subtitle: '请输入验证器应用中的验证码。',
      code: '验证码',
      submit: '验证',
      loading: '验证中...',
      useBackupCode: '使用备用码',
    },
    errors: {
      invalidCredentials: '邮箱或密码错误',
      emailRequired: '请输入邮箱',
      passwordRequired: '请输入密码',
      usernameRequired: '请输入用户名',
      invalidEmail: '邮箱格式不正确',
      passwordMismatch: '两次输入的密码不一致',
      weakPassword: '密码强度不够',
      usernameTaken: '用户名已被使用',
      emailTaken: '邮箱已被注册',
      accountLocked: '账户已被锁定，请稍后再试。',
      tooManyAttempts: '尝试次数过多，请稍后再试。',
    },
  },

  // Dashboard
  dashboard: {
    title: '仪表盘',
    welcome: '欢迎回来，{name}！',
    totalBalance: '总资产',
    todayPnL: '今日盈亏',
    portfolioValue: '资产价值',
    recentActivity: '最近活动',
    quickActions: '快捷操作',
    deposit: '充值',
    withdraw: '提现',
    trade: '交易',
    viewAll: '查看全部',
  },

  // Settings
  settings: {
    title: '设置',
    preferences: {
      title: '偏好设置',
      language: '语言',
      timezone: '时区',
      theme: '主题',
      themeLight: '浅色',
      themeDark: '深色',
      themeSystem: '跟随系统',
    },
    trading: {
      title: '交易设置',
      defaultSlippage: '默认滑点容忍度',
      slippageDescription: '您愿意接受的最大价格差异',
    },
    security: {
      title: '安全设置',
      withdrawWhitelist: '提现白名单',
      withdrawWhitelistDescription: '仅允许提现到白名单地址',
    },
    notifications: {
      title: '通知设置',
      email: '邮件通知',
      push: '推送通知',
      trade: '交易通知',
      security: '安全提醒',
      marketing: '营销推广',
    },
    saveAll: '保存所有设置',
    saving: '保存中...',
    saved: '设置已保存',
  },

  // Security
  security: {
    title: '安全',
    twoFactor: {
      title: '两步验证',
      description: '为您的账户添加额外的安全保护',
      enabled: '两步验证已启用',
      disabled: '两步验证未启用',
      enable: '启用两步验证',
      disable: '禁用两步验证',
      setup: {
        title: '设置两步验证',
        step1: '下载验证器应用',
        step1Description: '下载 Google Authenticator、Authy 或其他 TOTP 应用。',
        step2: '扫描二维码',
        step2Description: '打开验证器应用，扫描下方的二维码。',
        step3: '输入验证码',
        step3Description: '输入验证器应用中显示的 6 位验证码。',
        secretKey: '密钥（手动输入）',
        verificationCode: '验证码',
        submit: '启用两步验证',
      },
      backupCodes: {
        title: '备用码',
        description: '请将这些备用码保存在安全的地方。每个备用码只能使用一次。',
        download: '下载备用码',
        regenerate: '重新生成',
        warning: '这些备用码不会再次显示，请现在保存。',
      },
      methods: {
        title: '验证方式',
        totp: {
          name: '验证器应用',
          description: '使用 Google Authenticator、Authy 等应用',
        },
        email: {
          name: '邮箱验证',
          description: '通过邮箱接收验证码',
          enable: '启用邮箱验证',
          disable: '禁用邮箱验证',
          codeSent: '验证码已发送到您的邮箱',
        },
        sms: {
          name: '短信验证',
          description: '通过手机短信接收验证码',
          enable: '启用短信验证',
          disable: '禁用短信验证',
          codeSent: '验证码已发送到您的手机',
          phoneRequired: '请先验证您的手机号码',
        },
      },
      enterCode: '输入验证码',
      sendCode: '发送验证码',
      resendCode: '重新发送',
      codeExpires: '验证码将在 {time} 后过期',
    },
    phone: {
      title: '手机号码',
      description: '添加并验证您的手机号码以启用短信验证',
      verified: '已验证',
      notVerified: '未验证',
      update: '更新手机号',
      verify: '验证手机',
      sendCode: '发送验证码',
      enterCode: '输入发送到您手机的验证码',
      placeholder: '输入手机号码（例如：+86 138 1234 5678）',
    },
    sessions: {
      title: '活跃会话',
      description: '管理您的登录会话',
      current: '当前会话',
      revokeAll: '撤销所有其他会话',
      revoke: '撤销',
      device: '设备',
      ip: 'IP 地址',
      lastActive: '最后活跃',
    },
    apiKeys: {
      title: 'API 密钥',
      description: '管理您的 API 密钥以进行程序化访问',
      create: '创建新密钥',
      noKeys: '暂无 API 密钥',
      name: '密钥名称',
      permissions: '权限',
      created: '创建时间',
      lastUsed: '最后使用',
      expires: '过期时间',
      never: '永不',
      revoke: '撤销',
      warning: '此密钥只会显示一次，请立即复制保存。',
    },
    changePassword: {
      title: '修改密码',
      current: '当前密码',
      new: '新密码',
      confirm: '确认新密码',
      submit: '修改密码',
      success: '密码修改成功',
    },
    recovery: {
      title: '密码找回',
      email: '通过邮箱找回',
      sms: '通过短信找回',
      enterEmail: '请输入您的邮箱地址',
      enterPhone: '请输入您的手机号码',
      sendResetLink: '发送重置链接',
      sendResetCode: '发送重置验证码',
    },
  },

  // Wallet
  wallet: {
    title: '钱包',
    deposit: '充值',
    withdraw: '提现',
    transfer: '转账',
    history: '历史记录',
    asset: '资产',
    available: '可用',
    inOrders: '挂单冻结',
    totalBalance: '总余额',
    noAssets: '暂无资产',
    depositAddress: '充值地址',
    withdrawAddress: '提现地址',
    amount: '数量',
    memo: '备注/标签',
    network: '网络',
    fee: '网络手续费',
    minAmount: '最小数量',
    processing: '处理中',
    confirmations: '确认数',
  },

  // Trade
  trade: {
    title: '交易',
    buy: '买入',
    sell: '卖出',
    market: '市价',
    limit: '限价',
    stop: '止损',
    price: '价格',
    amount: '数量',
    total: '总额',
    available: '可用',
    orderBook: '订单簿',
    recentTrades: '最新成交',
    openOrders: '当前委托',
    orderHistory: '历史委托',
    tradeHistory: '成交记录',
    noOrders: '暂无委托',
    noTrades: '暂无成交',
    cancel: '撤销',
    cancelAll: '全部撤销',
    slippage: '滑点容忍度',
  },

  // Profile
  profile: {
    title: '个人资料',
    username: '用户名',
    displayName: '显示名称',
    email: '邮箱',
    phone: '手机号',
    bio: '个人简介',
    avatar: '头像',
    changeAvatar: '更换头像',
    joined: '注册时间',
    kyc: {
      title: '身份认证',
      level: '认证等级',
      unverified: '未认证',
      basic: '基础认证',
      advanced: '高级认证',
      startVerification: '开始认证',
      continueVerification: '继续认证',
      limits: '交易限额',
    },
  },

  // Errors
  errors: {
    general: '出错了，请重试。',
    network: '网络错误，请检查您的网络连接。',
    notFound: '页面未找到',
    unauthorized: '请登录后继续',
    forbidden: '您没有权限访问此资源',
    serverError: '服务器错误，请稍后重试。',
    validation: '请检查输入后重试',
    sessionExpired: '会话已过期，请重新登录。',
  },

  // Time
  time: {
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    daysAgo: '{n} 天前',
    weeksAgo: '{n} 周前',
    monthsAgo: '{n} 个月前',
    yearsAgo: '{n} 年前',
  },

  // Assets
  assets: {
    title: '数字资产',
    subtitle: '探索代币化数字资产',
    market: '资产市场',
    marketSubtitle: '发现并交易代币化数字资产',
    myAssets: '我的资产',
    myAssetsSubtitle: '管理您发行的资产和申请',
    myApplications: '我的申请',
    myHoldings: '我的持仓',
    holdingsSubtitle: '查看您的代币余额',
    issuedAssets: '已发行资产',
    apply: '申请上线',
    noAssets: '暂无可用资产',
    noAssetsHint: '请稍后再查看新上线资产',
    noApplications: '暂无申请',
    noHoldings: '暂无持仓',
    noIssuedAssets: '您还没有发行任何资产',
    noIssuedAssetsHint: '申请上线您的第一个数字资产',

    // Asset details
    symbol: '代币符号',
    name: '名称',
    description: '描述',
    assetType: '资产类型',
    totalSupply: '总供应量',
    circulatingSupply: '流通供应量',
    decimals: '小数位数',
    phase: '阶段',
    issuer: '发行方',
    holders: '持有人',
    listedAt: '上线时间',
    createdAt: '创建时间',
    launchedAt: '发布时间',
    price: '价格',
    marketCap: '市值',
    bondingProgress: 'Bonding 进度',
    raised: '已募集',
    complete: '完成',
    topHolders: '持仓排行',

    // Trading
    trade: '交易',
    buy: '买入',
    sell: '卖出',
    enterAmount: '输入数量',
    estimatedCost: '预估花费',
    estimatedReceive: '预估收益',
    advancedTrading: '高级交易',
    tradingSuspended: '该资产交易已暂停',

    // Stats
    stats24h: '24小时统计',
    volume24h: '24小时成交量',
    high24h: '24小时最高',
    low24h: '24小时最低',
    transactions: '交易笔数',

    // Asset types
    types: {
      database: '数据库',
      content: '内容',
      infrastructure: '基础设施',
      other: '其他',
    },

    // Asset phases
    phases: {
      application: '申请中',
      bonding: 'Bonding 曲线',
      trading: '交易中',
      suspended: '已暂停',
      delisted: '已下线',
    },

    // Application
    application: {
      title: '资产上线申请',
      subtitle: '申请将您的数字资产上线至 TokenForge',
      create: '创建申请',
      edit: '编辑申请',
      view: '查看申请',
      submit: '提交审核',
      cancel: '取消申请',
      saveDraft: '保存草稿',

      // Steps
      steps: {
        basicInfo: '基本信息',
        tokenomics: '代币经济',
        bondingCurve: 'Bonding 曲线',
        documents: '文档资料',
        review: '审核提交',
      },

      // Fields
      fields: {
        name: '资产名称',
        nameHint: '您的资产的正式名称（例如："DataToken"）',
        symbol: '代币符号',
        symbolHint: '2-10个大写字母/数字（例如："DATA"）',
        description: '描述',
        descriptionHint: '描述您的资产及其用途',
        assetType: '资产类型',
        assetTypeHint: '选择最能描述您资产的类别',
        totalSupply: '总供应量',
        totalSupplyHint: '将要存在的最大代币数量',
        decimals: '小数位数',
        decimalsHint: '小数位数（0-18）',
        curveType: '曲线类型',
        curveTypeHint: '选择 Bonding 曲线模型',
        basePrice: '基础价格（USDT）',
        basePriceHint: '每个代币的起始价格',
        slope: '斜率',
        slopeHint: '每卖出一个代币的价格增长（线性曲线）',
        growthRate: '增长率',
        growthRateHint: '指数增长率（指数曲线）',
        targetRaise: '目标筹资（USDT）',
        targetRaiseHint: '您计划筹集的总金额',
        launchThreshold: '启动阈值（%）',
        launchThresholdHint: '启动交易所需达到的目标百分比',
        distributionPlan: '分配计划',
        distributionPlanHint: '描述代币将如何分配',
        ownershipProof: '所有权证明',
        ownershipProofHint: '上传证明您所有权的文件',
        revenueProof: '收益证明（可选）',
        revenueProofHint: '如有，上传历史收益数据',
        evaluationReport: '评估报告（可选）',
        evaluationReportHint: '上传第三方估值报告',
      },

      // Curve types
      curveTypes: {
        linear: '线性',
        linearDesc: '价格随供应量线性增长',
        exponential: '指数',
        exponentialDesc: '价格呈指数增长',
        sigmoid: 'S形曲线',
        sigmoidDesc: '先缓慢增长，然后陡峭，再缓慢',
      },

      // Status
      status: {
        draft: '草稿',
        submitted: '已提交',
        reviewing: '审核中',
        approved: '已通过',
        rejected: '已拒绝',
        cancelled: '已取消',
      },

      // Messages
      messages: {
        created: '申请创建成功',
        updated: '申请更新成功',
        submitted: '申请已提交审核',
        cancelled: '申请已取消',
        rejected: '您的申请已被拒绝',
        approved: '您的申请已通过！',
      },

      // Validation
      validation: {
        nameRequired: '请输入资产名称',
        symbolRequired: '请输入代币符号',
        symbolFormat: '代币符号必须是2-10个大写字母/数字',
        symbolTaken: '该符号已被使用',
        descriptionRequired: '请输入描述',
        totalSupplyRequired: '请输入总供应量',
        totalSupplyPositive: '总供应量必须为正数',
        basePriceRequired: '请输入基础价格',
        targetRaiseRequired: '请输入目标筹资金额',
        distributionPlanRequired: '请输入分配计划',
        ownershipProofRequired: '请至少上传一份所有权证明文件',
        slopeRequired: '线性曲线需要设置斜率',
        growthRateRequired: '指数曲线需要设置增长率',
      },
    },

    // Statistics
    stats: {
      title: '资产统计',
      holderCount: '持有人数',
      largestHolding: '最大持仓',
      averageHolding: '平均持仓',
      topHolders: '持仓排行',
    },
  },

  // AMM Pool
  pool: {
    title: '流动性池',
    subtitle: '交易代币并提供流动性',
    totalPools: '流动性池总数',
    totalTvl: '总锁仓价值',
    volume24h: '24小时交易量',
    activeTraders: '活跃交易者',
    noPoolsTitle: '暂无流动性池',
    noPoolsDescription: '资产完成 Bonding 曲线阶段后，流动性池将在此显示。',
    myPositions: '我的仓位',

    // Pool details
    detail: {
      title: '池详情',
      reserves: '池储备',
      tokenReserve: '代币储备',
      quoteReserve: 'USDT 储备',
      lpTotalSupply: 'LP 代币总量',
      lpProviders: 'LP 提供者数量',
      currentPrice: '当前价格',
      tvl: '总锁仓价值',
      fees24h: '24小时手续费',
      apy: '年化收益率',
      feeRate: '手续费率',
      recentTrades: '最新交易',
      liquidityEvents: '流动性事件',
    },

    // Chart
    chart: {
      loading: '加载图表中...',
      noData: '暂无图表数据',
      expand: '展开',
      collapse: '收起',
      fullscreen: '全屏',
      exitFullscreen: '退出全屏',
      intervals: {
        '1m': '1分',
        '5m': '5分',
        '15m': '15分',
        '1h': '1时',
        '4h': '4时',
        '1d': '1日',
        '1w': '1周',
      },
      types: {
        candlestick: 'K线',
        line: '折线',
        area: '面积',
      },
      indicators: {
        title: '指标',
        ma: 'MA',
        ema: 'EMA',
        rsi: 'RSI',
        macd: 'MACD',
        bb: '布林带',
      },
      stats: {
        price: '价格',
        change24h: '24小时涨跌',
        high24h: '24小时最高',
        low24h: '24小时最低',
        volume24h: '24小时成交量',
        trades24h: '24小时交易数',
      },
    },

    // Swap
    swap: {
      title: '兑换',
      from: '从',
      to: '至',
      balance: '余额',
      max: '最大',
      rate: '汇率',
      priceImpact: '价格影响',
      fee: '手续费',
      minReceived: '最少收到',
      slippageTolerance: '滑点容忍度',
      connectWallet: '连接钱包',
      enterAmount: '输入数量',
      insufficientBalance: '余额不足',
      swap: '兑换',
      swapping: '兑换中...',
      swapSuccess: '兑换成功',
      swapFailed: '兑换失败',
      settings: '兑换设置',
    },

    // Liquidity
    liquidity: {
      title: '管理流动性',
      add: '添加流动性',
      remove: '移除流动性',
      addLiquidity: '添加流动性',
      removeLiquidity: '移除流动性',
      poolShare: '池份额',
      lpTokens: 'LP 代币',
      lpTokensToReceive: '将获得的 LP 代币',
      amountToRemove: '移除数量',
      outputEstimate: '您将收到',
      slippageWarning: '输出金额为估算值。您将至少收到所显示金额的 {percent}%。',
      addSuccess: '流动性添加成功',
      addFailed: '添加流动性失败',
      removeSuccess: '流动性移除成功',
      removeFailed: '移除流动性失败',
      noLpTokens: '无 LP 代币',
      insufficientToken: '{symbol} 余额不足',
      insufficientUsdt: 'USDT 余额不足',
    },

    // Position
    position: {
      title: '您的仓位',
      noPosition: '您在此池中没有流动性',
      lpBalance: 'LP 代币余额',
      tokenValue: '代币价值',
      quoteValue: 'USDT 价值',
      feesEarned: '已赚取手续费',
      managePosition: '管理仓位',
    },

    // Admin
    admin: {
      title: '流动性池管理',
      subtitle: '管理 AMM 流动性池',
      createPool: '创建流动性池',
      pausePool: '暂停流动性池',
      resumePool: '恢复流动性池',
      updateFee: '更新手续费率',
      paused: '流动性池已暂停',
      resumed: '流动性池已恢复',
      feeUpdated: '手续费率更新成功',
      poolCreated: '流动性池创建成功',
      confirmPause: '确定要暂停此流动性池吗？用户将无法进行兑换或添加流动性。',
      topLpHolders: 'LP 持仓排行',
      recentSwaps: '最新兑换',
      statsOverview: '统计概览',
    },
  },
};
